(function () {
  function closeMenu() {
    document.body.classList.remove('menu-open');
    var button = document.querySelector('[data-menu]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-menu]');
    if (button) {
      var open = !document.body.classList.contains('menu-open');
      document.body.classList.toggle('menu-open', open);
      button.setAttribute('aria-expanded', String(open));
      var drawer = document.querySelector('[data-mobile-drawer]');
      if (drawer) drawer.setAttribute('aria-hidden', String(!open));
      return;
    }

    if (event.target.closest('[data-mobile-drawer] a')) closeMenu();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });
})();
